import { takeEvery, call, put } from 'redux-saga/effects';
import map from 'lodash.map';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { replace } from 'react-router-redux';
import queryString from 'qs';
import { ProjectActions } from '../actions';
import { getErrorForToastr } from '../utils/error-adapter';

const projectUrl = '/api/project';
const projectCommentsUrl = '/api/project/comments';

export function* watchFetchProjectsByType() {
	yield takeEvery(ProjectActions.FetchProjectsByTypeAction.Request, fetchProjectsByType);
}
function* fetchProjectsByType(action) {
	let { page, size, projectType, isActual, searchTerm, voteMode, projectMode, category } = action.payload;
	try {
		const projects = yield call(fetchProjectsByTypeRequest, {
			page,
			size,
			projectType,
			isActual,
			searchTerm,
			voteMode,
			projectMode,
			category
		});
		yield put({
			type: ProjectActions.FetchProjectsByTypeAction.Success,
			payload: projects
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (e) {
		yield put({ type: ProjectActions.FetchProjectsByTypeAction.Failure });
		toastr.error('Błąd pobierania projektów', 'Wystąpił niespodziewany błąd podczas pobierania listy projektów');
	}
}
export function* watchFetchArchiveProjectsByType() {
	yield takeEvery(ProjectActions.FetchArchiveProjectsByTypeAction.Request, fetchArchiveProjectsByType);
}
function* fetchArchiveProjectsByType(action) {
	let {
		archiveListPage: page,
		archiveListSize: size,
		projectType,
		isActual,
		searchTerm,
		voteMode,
		projectMode,
		category
	} = action.payload;
	try {
		const projects = yield call(fetchProjectsByTypeRequest, {
			page,
			size,
			projectType,
			isActual,
			searchTerm,
			voteMode,
			projectMode,
			category
		});
		yield put({
			type: ProjectActions.FetchArchiveProjectsByTypeAction.Success,
			payload: projects
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (e) {
		yield put({ type: ProjectActions.FetchArchiveProjectsByTypeAction.Failure });
		toastr.error('Błąd pobierania projektów', 'Wystąpił niespodziewany błąd podczas pobierania listy projektów');
	}
}
function fetchProjectsByTypeRequest(filter) {
	var query = queryString.stringify(filter, { skipNulls: true, addQueryPrefix: true });
	return axios.get(`${projectUrl}${query}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchGetProject() {
	yield takeEvery(ProjectActions.GetProjectAction.Request, getProject);
}
function* getProject(action) {
	try {
		const project = yield call(getProjectRequest, action.payload.id, action.payload.clientId);
		yield put({
			type: ProjectActions.GetProjectAction.Success,
			payload: { ...project, opinionActionId: action.payload.id }
		});
	} catch (e) {
		yield put({ type: ProjectActions.GetProjectAction.Failure });
		toastr.error('Błąd pobierania projektu', 'Wystąpił niespodziewany błąd podczas pobierania projektu');
	}
}
function getProjectRequest(id, clientId = null) {
	let url = `${projectUrl}/${id}`;
	if (clientId) {
		url = `${url}/${clientId}`;
	}
	return axios.get(`${url}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}
export function* watchGetProjectHeader() {
	yield takeEvery(ProjectActions.GetProjectHeaderAction.Request, getProjectHeader);
}
function* getProjectHeader(action) {
	try {
		const project = yield call(getProjectHeaderRequest, action.payload);
		yield put({
			type: ProjectActions.GetProjectHeaderAction.Success,
			payload: project
		});
	} catch (e) {
		yield put({ type: ProjectActions.GetProjectHeaderAction.Failure });
		toastr.error('Błąd pobierania projektu', 'Wystąpił niespodziewany błąd podczas pobierania projektu');
	}
}
function getProjectHeaderRequest(id) {
	return axios.get(`${projectUrl}/${id}/header`).then((response) => response.data).catch((err) => {
		throw err;
	});
}
export function* watchUpdateConsultationForm() {
	yield takeEvery(ProjectActions.UpdateConsultationFormAction.Request, updateConsultationForm);
}
function* updateConsultationForm(action) {
	try {
		const project = yield call(updateConsultationFormRequest, action.payload);

		let consultationFormIds = map(action.payload.consultationForms, (cf) => cf.id);
		yield put({
			type: ProjectActions.UpdateConsultationFormAction.Success,
			payload: { project, consultationFormIds: consultationFormIds }
		});
		toastr.success('Udział w głosowaniu', 'Poprawnie oddano głos');
	} catch (err) {
		let consultationFormIds = map(action.payload.consultationForms, (cf) => cf.id);
		yield put({ type: ProjectActions.UpdateConsultationFormAction.Failure, payload: consultationFormIds });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd udziału w głosowaniu',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas udziału w głosowaniu.'
		);
	}
}
function updateConsultationFormRequest(payload) {
	return axios
		.put(`${projectUrl}/${payload.projectId}/consultation-forms`, {
			consultationForms: payload.consultationForms,
			userData: payload.userData,
			authorizeCode: payload.authorizeCode
		})
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}

export function* watchSaveComment() {
	yield takeEvery(ProjectActions.SaveCommentAction.Request, saveComment);
}
function* saveComment(action) {
	try {
		const project = yield call(saveCommentRequest, action.payload);
		yield put({
			type: ProjectActions.SaveCommentAction.Success,
			payload: { ...project, opinionActionId: action.payload.id }
		});
		toastr.success('Komentarz', 'Poprawnie dodano komentarz. Proszę czekać na weryfikację.');
	} catch (err) {
		yield put({ type: ProjectActions.SaveCommentAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd komentarza',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas dodawania komentarza.'
		);
	}
}
function saveCommentRequest(comment) {
	return axios.post(`${projectCommentsUrl}`, comment).then((response) => response.data).catch((err) => {
		throw err;
	});
}
export function* watchAddCommentOpinion() {
	yield takeEvery(ProjectActions.AddCommentOpinionAction.Request, addCommentOpinion);
}
function* addCommentOpinion(action) {
	try {
		const project = yield call(addCommentOpinionRequest, action.payload.id, action.payload.type);
		yield put({
			type: ProjectActions.AddCommentOpinionAction.Success,
			payload: { ...project, opinionActionId: action.payload.id }
		});
	} catch (err) {
		yield put({ type: ProjectActions.AddCommentOpinionAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd oceny komentarza',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas dodawania oceny komentarza.'
		);
	}
}
function addCommentOpinionRequest(id, type) {
	return axios
		.post(`${projectCommentsUrl}/opinions`, { commentId: id, type: type })
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}
export function* watchRemoveCommentOpinion() {
	yield takeEvery(ProjectActions.RemoveCommentOpinionAction.Request, removeCommentOpinion);
}
function* removeCommentOpinion(action) {
	try {
		const project = yield call(removeCommentOpinionRequest, action.payload.id);
		yield put({
			type: ProjectActions.RemoveCommentOpinionAction.Success,
			payload: { ...project, opinionActionId: action.payload.id }
		});
	} catch (err) {
		yield put({ type: ProjectActions.RemoveCommentOpinionAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd oceny komentarza',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas wycofania oceny komentarza.'
		);
	}
}
function removeCommentOpinionRequest(id) {
	return axios.delete(`${projectCommentsUrl}/opinions/${id}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchAddProjectOpinion() {
	yield takeEvery(ProjectActions.AddProjectOpinionAction.Request, addProjectOpinion);
}
function* addProjectOpinion(action) {
	try {
		const project = yield call(addProjectOpinionRequest, action.payload.id, action.payload.type);
		yield put({
			type: ProjectActions.AddProjectOpinionAction.Success,
			payload: { ...project, opinionActionId: action.payload.id }
		});
	} catch (err) {
		yield put({ type: ProjectActions.AddProjectOpinionAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd oceny konsultacji',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas dodawania oceny konsultacji.'
		);
	}
}
function addProjectOpinionRequest(id, type) {
	return axios
		.post(`${projectUrl}/opinions`, { projectId: id, type: type })
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}
export function* watchRemoveProjectOpinion() {
	yield takeEvery(ProjectActions.RemoveProjectOpinionAction.Request, removeProjectOpinion);
}
function* removeProjectOpinion(action) {
	try {
		const project = yield call(removeProjectOpinionRequest, action.payload.id);
		yield put({
			type: ProjectActions.RemoveProjectOpinionAction.Success,
			payload: { ...project, opinionActionId: action.payload.id }
		});
	} catch (err) {
		yield put({ type: ProjectActions.RemoveProjectOpinionAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd oceny konsultacji',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas wycofania oceny konsultacji.'
		);
	}
}
function removeProjectOpinionRequest(id) {
	return axios.delete(`${projectUrl}/opinions/${id}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchGetBudgetVoteProjects() {
	yield takeEvery(ProjectActions.GetBudgetVoteProjectsAction.Request, getBudgetVoteProjects);
}
function* getBudgetVoteProjects(action) {
	try {
		const projects = yield call(getBudgetVoteProjectsRequest, action.payload.year, action.payload.filter);
		yield put({
			type: ProjectActions.GetBudgetVoteProjectsAction.Success,
			payload: projects
		});
		let searchTermFilter = action.payload
			? queryString.stringify(action.payload, { skipNulls: true, addQueryPrefix: true })
			: '';
		yield put(replace(`${window.location.pathname}${searchTermFilter}`));
	} catch (e) {
		yield put({ type: ProjectActions.GetBudgetVoteProjectsAction.Failure });
		toastr.error('Błąd pobierania projektów', 'Wystąpił niespodziewany błąd podczas pobierania listy projektów');
	}
}
function getBudgetVoteProjectsRequest(year, filter) {
	var query = queryString.stringify(filter, { skipNulls: true, addQueryPrefix: true });
	return axios.get(`${projectUrl}/budgets/${year}${query}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchGenerateNewAuthorizeCode() {
	yield takeEvery(ProjectActions.GenerateNewAuthorizeCodeAction.Request, generateNewAuthorizeCode);
}
function* generateNewAuthorizeCode(action) {
	try {
		const project = yield call(generateNewAuthorizeCodeRequest, action.payload);
		yield put({
			type: ProjectActions.GenerateNewAuthorizeCodeAction.Success
		});
		toastr.success('Generowanie kodu autoryzacji', 'Wygenerowano nowy kod autoryzacji dla głosowania. Sprawdź skrzynkę e-mail');
	} catch (err) {
		yield put({ type: ProjectActions.GenerateNewAuthorizeCodeAction.Failure });
		let toastrError = getErrorForToastr(err);
		toastr.error(
			toastrError.title || 'Błąd generowania kodu autoryzacji głosowania',
			toastrError.message || 'Wystąpił niespodziewany błąd podczas generowania kodu autoryzacji głosowaniu.'
		);
	}
}
function generateNewAuthorizeCodeRequest(payload) {
	return axios
		.post(`${projectUrl}/${payload.projectId}/authorize-code`, payload.userData)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}
